import React, { Component, createRef } from 'react';
import { PropTypes } from 'prop-types';
import { withTheme } from 'styled-components';
import { MenuItem } from '@movember/mo-gel/components/MenuItem';
import { Icon } from '@movember/mo-gel/components/Icon';
import { Text } from '@movember/mo-gel';

import { OverlayPanel } from '../../../components-global';
import { ReactComponent as CloseIcon } from '../../../images/icons/icon_close.svg';
import { StyledOutcomesEdit, StyledCloseIconContainer } from './StickyMenuItem.styled';

class StickyMenuItem extends Component {
  constructor(props) {
    super(props);

    this.menuItemRef = createRef();
    this.state = {
      displayInfoPanel: false,
      isOnDesktop: false,
      menuText: ''
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    const { theme, shortText, text } = this.props;
    const screenSize = window.innerWidth;
    // here we slice the px out of the breakpoint value
    const breakpointValue = theme.breakpoints.md.slice(0, -2);

    if (screenSize >= parseInt(breakpointValue, 10)) {
      this.setState({ isOnDesktop: true });
    } else {
      const xSmallBreakpointValue = theme.breakpoints.sm.slice(0, -2);
      const isOnMobile = screenSize < parseInt(xSmallBreakpointValue, 10);
      this.setState({ isOnDesktop: false, menuText: isOnMobile ? shortText : text });
    }

    // trigger closeMenu when resizing
    this.closeMenu();
  };

  onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { onClick, menuDisabled } = this.props;
    const { displayInfoPanel } = this.state;

    if (displayInfoPanel) {
      this.closeMenu();
    } else if (onClick && !menuDisabled) {
      this.setState({ displayInfoPanel: true });
      onClick(event);
    }
  };

  closeMenu = () => {
    const { onClose } = this.props;
    this.setState({ displayInfoPanel: false });
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { displayInfoPanel, isOnDesktop, menuText } = this.state;
    const { menuDisabled, icon, children, closeIconVisible, text } = this.props;
    const MenuIcon = icon;
    const panelDirection = isOnDesktop ? 'slide-right' : 'slide-down';

    return (
      <StyledOutcomesEdit
        onClick={this.onClick}
        isBlurred={menuDisabled}
        ref={this.menuItemRef}
        data-track-type="Sticky Nav Item"
        data-track-location={text}
      >
        <MenuItem text={menuText} disabled={menuDisabled}>
          <Icon>
            <MenuIcon />
          </Icon>
          <Text size="xSmall">{menuText}</Text>
        </MenuItem>
        {displayInfoPanel && (
          <OverlayPanel target={this.menuItemRef.current} onClickOutside={this.closeMenu} direction={panelDirection}>
            {closeIconVisible && (
              <StyledCloseIconContainer onClick={this.closeMenu}>
                <CloseIcon />
              </StyledCloseIconContainer>
            )}
            {children}
          </OverlayPanel>
        )}
      </StyledOutcomesEdit>
    );
  }
}

const StickyMenuItemWrapper = withTheme(StickyMenuItem);
export { StickyMenuItemWrapper as StickyMenuItem };

StickyMenuItem.defaultProps = {
  children: [],
  menuDisabled: false,
  icon: null,
  text: '',
  shortText: '',
  closeIconVisible: false,
  onClick: null,
  onClose: null
};

StickyMenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  menuDisabled: PropTypes.bool,
  icon: PropTypes.objectOf(PropTypes.any),
  text: PropTypes.string,
  shortText: PropTypes.string,
  closeIconVisible: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func
};
